import allInHandleWishlist from "@magalu/ecomm-components/rave/events/AllIn/handleWishlist";
import allInPageView from "@magalu/ecomm-components/rave/events/AllIn/pageView";
import { cloudRetailAddToCart } from "@magalu/ecomm-components/rave/events/CloudRetail/addToCart";
import { cloudRetailView } from "@magalu/ecomm-components/rave/events/CloudRetail/viewItem";
import addToCartSuccessCookie from "@magalu/ecomm-components/rave/events/Cookies/addToCart";
import gaAddToCartSuccessCookie from "@magalu/ecomm-components/rave/events/Cookies/gaAddToCart";
import criteoPageView from "@magalu/ecomm-components/rave/events/Criteo/pageView";
import { addToCartError } from "@magalu/ecomm-components/rave/events/GA/add-to-cart";
import { brandListItemClick } from "@magalu/ecomm-components/rave/events/GA/all-brands";
import { productAttributeClick } from "@magalu/ecomm-components/rave/events/GA/attribute";
import {
  triggerCardanAskSellerClickEvent,
  triggerCardanChangeVehicleClickEvent,
  triggerCardanViewContentEvent,
} from "@magalu/ecomm-components/rave/events/GA/cardan-pdp";
import { filterLinkListClick } from "@magalu/ecomm-components/rave/events/GA/filter";
import {
  luContentClick,
  luContentView,
} from "@magalu/ecomm-components/rave/events/GA/luContent";
import { clickPagination } from "@magalu/ecomm-components/rave/events/GA/pagination";
import { productLabelClick } from "@magalu/ecomm-components/rave/events/GA/product-label";
import {
  productPaymentChange,
  productPaymentClick,
} from "@magalu/ecomm-components/rave/events/GA/product-payment";
import { productViewItem } from "@magalu/ecomm-components/rave/events/GA/product-view-item";
import {
  productBenefitCardClick,
  productBenefitsRefundLinkClick,
  productBenefitsView,
} from "@magalu/ecomm-components/rave/events/GA/productBenefit";
import { promoterOfferButtonClick } from "@magalu/ecomm-components/rave/events/GA/promoterOffer";
import {
  questionListImpression,
  questionFormSeeMore,
  questionClickConfirmQuestion,
  questionClickOpenConfirm,
  questionFeedbackResponseError,
} from "@magalu/ecomm-components/rave/events/GA/questions";
import {
  reviewPdpClick,
  reviewSeeMoreClick,
} from "@magalu/ecomm-components/rave/events/GA/review";
import {
  searchClear,
  searchClose,
} from "@magalu/ecomm-components/rave/events/GA/search";
import {
  sellerInfoPdpLinkClick,
  sellerScoreImpression,
  sellerScoreCalcInfoClick,
} from "@magalu/ecomm-components/rave/events/GA/seller";
import { showcaseItemClick } from "@magalu/ecomm-components/rave/events/GA/showcase-item-click";
import { showcaseItemView } from "@magalu/ecomm-components/rave/events/GA/showcase-item-view";
import {
  zipCodeClick,
  zipCodeResponseError,
  zipCodeResponseSuccess,
} from "@magalu/ecomm-components/rave/events/GA/zipCode";
import { addToCart } from "@magalu/ecomm-components/rave/events/GA4/addToCart";
import { addToWishList } from "@magalu/ecomm-components/rave/events/GA4/addToWishList";
import {
  seeMoreOffers,
  buyBoxAddToCart,
} from "@magalu/ecomm-components/rave/events/GA4/buyBox";
import { calculateTaxes } from "@magalu/ecomm-components/rave/events/GA4/calculateTaxes";
import { chatSellerSelectContent } from "@magalu/ecomm-components/rave/events/GA4/chatSeller";
import {
  couponSelectContent,
  couponViewContent,
} from "@magalu/ecomm-components/rave/events/GA4/coupon";
import { footerItemClick } from "@magalu/ecomm-components/rave/events/GA4/footer";
import {
  clickMenuItem,
  clickMenuButton,
  clickDropdownMenu,
  clickBasketButton,
  clickAccountOption,
  clickDeliveryAt,
  clickSignupOrLogin,
  clickZipcodeModalLoginButton,
  selectDeliveryAddress,
} from "@magalu/ecomm-components/rave/events/GA4/header";
import { hotlinkClick } from "@magalu/ecomm-components/rave/events/GA4/hotlinks";
import { importTaxesInfoModalClose } from "@magalu/ecomm-components/rave/events/GA4/importTaxesInfoModalClose";
import { productDetailView } from "@magalu/ecomm-components/rave/events/GA4/productDetailView";
import {
  productDisplayClick,
  productDisplayView,
} from "@magalu/ecomm-components/rave/events/GA4/productRating";
import {
  productSellerClick,
  productSellerChat,
} from "@magalu/ecomm-components/rave/events/GA4/productSeller";
import {
  selectPromotionBanner,
  viewPromotionBanner,
  selectPromotionBannerVideo,
  viewPromotionBannerVideo,
  videoCompletePromotionBanner,
  videoProgressPromotionBanner,
  videoStartPromotionBanner,
} from "@magalu/ecomm-components/rave/events/GA4/promotionBanner";
import { removeFromWishlistSelectContent } from "@magalu/ecomm-components/rave/events/GA4/removeFromWishlist";
import {
  reviewSelectContent,
  reviewSelectBackToHome,
  reviewSendContent,
} from "@magalu/ecomm-components/rave/events/GA4/review";
import { submitSearchInput } from "@magalu/ecomm-components/rave/events/GA4/search";
import { selectItem } from "@magalu/ecomm-components/rave/events/GA4/selectItem";
import {
  selectSellerBanner,
  viewSellerBanner,
} from "@magalu/ecomm-components/rave/events/GA4/sellerBanner";
import { shareClick } from "@magalu/ecomm-components/rave/events/GA4/share";
import { shippingGA4 } from "@magalu/ecomm-components/rave/events/GA4/shipping";
import { shippingResponseErrorGA4 } from "@magalu/ecomm-components/rave/events/GA4/shippingResponseErrorGA4";
import { shippingView } from "@magalu/ecomm-components/rave/events/GA4/shippingView";
import { showcaseLoadMoreSelectContent } from "@magalu/ecomm-components/rave/events/GA4/showcaseLoadMoreSelectContent";
import {
  videoCartInteraction,
  videoInteraction,
} from "@magalu/ecomm-components/rave/events/GA4/videoInteraction";
import { viewItem } from "@magalu/ecomm-components/rave/events/GA4/viewItem";
import { viewItemList } from "@magalu/ecomm-components/rave/events/GA4/viewItemList";
import { virtualPageview } from "@magalu/ecomm-components/rave/events/GA4/virtualPageview";
import rtbhAddToCart from "@magalu/ecomm-components/rave/events/RTBHouse/add-to-cart";
import rtbhAddToWishList from "@magalu/ecomm-components/rave/events/RTBHouse/add-to-wish-list";
import rtbhPageView from "@magalu/ecomm-components/rave/events/RTBHouse/page-view";
import spotifyAddToCart from "@magalu/ecomm-components/rave/events/SpotifyAdAnalytics/add-to-cart";
import spotifyAddToWishList from "@magalu/ecomm-components/rave/events/SpotifyAdAnalytics/add-to-wish-list";
import spotifyPageView from "@magalu/ecomm-components/rave/events/SpotifyAdAnalytics/page-view";
import stewieAddToCart from "@magalu/ecomm-components/rave/events/Stewie/add-to-cart";
import stewiePageView from "@magalu/ecomm-components/rave/events/Stewie/page-view";
import stewieProductListClick from "@magalu/ecomm-components/rave/events/Stewie/product-list-click";
import tiktokAddToCart from "@magalu/ecomm-components/rave/events/TikTok/add-to-cart";
import tikTokViewItem from "@magalu/ecomm-components/rave/events/TikTok/view-item";

import { recs } from "./constants/recs";
import { gateKeeperButtonClick } from "./events/gate-keeper";

const events = (): unknown => ({
  "addtocart:error": [addToCartError],
  "addtocart:success": [
    addToCart,
    addToCartSuccessCookie,
    gaAddToCartSuccessCookie,
    tiktokAddToCart,
    spotifyAddToCart,
    rtbhAddToCart,
    stewieAddToCart,
    cloudRetailAddToCart,
  ],
  "buybox:addtocart": [buyBoxAddToCart],
  "buybox:seemoreoffers": [seeMoreOffers],
  "buybox:selectItem": [selectItem],
  "buybox:viewitemlist": [viewItemList],
  "cardan:ask-seller-click": [triggerCardanAskSellerClickEvent],
  "cardan:change-vehicle-click": [triggerCardanChangeVehicleClickEvent],
  "cardan:view-content": [triggerCardanViewContentEvent],
  "click:brandListItem": [brandListItemClick],
  "click:pagination": [clickPagination],
  "click:promoterOffer:button": [promoterOfferButtonClick],
  "click:zipCodeBar": [zipCodeClick],
  "coupon:selectItem": [couponSelectContent],
  "coupon:viewItem": [couponViewContent],
  "footer:click:item": [footerItemClick],
  "gatekeeper:click": [gateKeeperButtonClick],
  "header:address:selected": [selectDeliveryAddress],
  "header:click:account-option": [clickAccountOption],
  "header:click:delivery-at": [clickDeliveryAt],
  "header:click:dropdown:item": [clickDropdownMenu],
  "header:click:menu:basket": [clickBasketButton],
  "header:click:menu:button": [clickMenuButton],
  "header:click:menu:item": [clickMenuItem],
  "header:click:signup-login": [clickSignupOrLogin],
  "header:click:zipcode-modal:login:button": [clickZipcodeModalLoginButton],
  "header:submit:search:input": [submitSearchInput],
  "hotlink:click": [hotlinkClick],
  "listlink:click": [filterLinkListClick],
  "lucontent:vertical:item:click": [luContentClick],
  "lucontent:vertical:item:view": [luContentView],
  pageView: [
    viewItem,
    tikTokViewItem,
    allInPageView,
    criteoPageView,
    spotifyPageView,
    rtbhPageView,
    stewiePageView,
    virtualPageview,
    cloudRetailView,
  ],
  "product:attribute:selected": [productAttributeClick],
  "product:benefits:refund:link:click": [productBenefitsRefundLinkClick],
  "product:benefits:tags:click": [productBenefitCardClick],
  "product:benefits:view": [productBenefitsView],
  "product:calculateTaxes": [calculateTaxes],
  "product:detail:view": [productDetailView],
  "product:display:click": [productDisplayClick],
  "product:display:review": [productDisplayView],
  "product:importTaxesClose:click": [importTaxesInfoModalClose],
  "product:installments:click": [productPaymentClick],
  "product:item:click": [selectItem, showcaseItemClick, stewieProductListClick],
  "product:item:view": [viewItemList],
  "product:label:click": [productLabelClick],
  "product:paymentmethod:change": [productPaymentChange],
  "product:rating:click": [reviewPdpClick],
  "product:seller:chat:click": [productSellerChat],
  "product:seller:click": [productSellerClick],
  "product:share:click": [shareClick],
  "product:shipping": [shippingGA4],
  "product:shipping:details": [productViewItem],
  "product:shipping:error": [shippingResponseErrorGA4],
  "product:shipping:view": [shippingView],
  "product:showcase:see-more:click": [showcaseLoadMoreSelectContent],
  "product:view": [viewItemList, showcaseItemView],
  "product:wishlist:click": [
    allInHandleWishlist,
    spotifyAddToWishList,
    rtbhAddToWishList,
    addToWishList,
    removeFromWishlistSelectContent,
  ],
  "productlist:click": [selectItem],
  "promotion:click": [selectPromotionBanner],
  "promotion:video:click": [selectPromotionBannerVideo],
  "promotion:video:complete": [videoCompletePromotionBanner],
  "promotion:video:progress": [videoProgressPromotionBanner],
  "promotion:video:start": [videoStartPromotionBanner],
  "promotion:video:view": [viewPromotionBannerVideo],
  "promotion:view": [viewPromotionBanner],
  "question-confirm:click": [questionClickConfirmQuestion],
  "question-feedback:error": [questionFeedbackResponseError],
  "question-form:see-more": [questionFormSeeMore],
  "question-list:impression": [questionListImpression],
  "question:form:submit": [questionClickOpenConfirm],
  "review:finishreview:success:backtohome": [reviewSelectBackToHome],
  "review:selectcontent:view-image": [reviewSelectContent],
  "review:selectcontent:view-video": [reviewSelectContent],
  "review:selectcontent:write-review": [reviewSelectContent],
  "review:sendcontent:send-image": [reviewSendContent],
  "review:sendcontent:send-tags": [reviewSendContent],
  "review:sendcontent:send-video": [reviewSendContent],
  "reviewpdp:button:click": [reviewSeeMoreClick],
  "search:clear": [searchClear],
  "search:close": [searchClose],
  "seller:banner:click": [selectSellerBanner],
  "seller:banner:view": [viewSellerBanner],
  "seller:info:impression": [sellerScoreImpression],
  "seller:info:pdp:open:modal:click": [sellerInfoPdpLinkClick],
  "seller:info:selectcontent:chatSeller:click": [chatSellerSelectContent],
  "seller:score:calc:info:click": [sellerScoreCalcInfoClick],
  "video:cart:interaction": [videoCartInteraction],
  "video:interaction": [videoInteraction],
  "zipcodebar:response:error": [zipCodeResponseError],
  "zipcodebar:response:success": [zipCodeResponseSuccess],
});

export default events;

export const config = {
  device: "mobile",
  recs,
};
